/* eslint-disable @typescript-eslint/no-explicit-any */
import { ItemInterface, InputType } from 'src/app/common/components/form-builder/form-builder.component';
import { environment } from 'src/environments/environment';

export class ClienteFormDefinition {
    appName = environment.appName;
    lastFieldChanged = '';

    requestType: any;
    model: any = {};

    formFieldsDatos: ItemInterface<any>[] = [{
        field: 'nombre',
        label: 'Nombre',
        inputType: { type: InputType.EDIT_TEXT },
        required: true,
    },
    {
        field: 'alias',
        label: 'Alias',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'email',
        label: 'Email',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'direccion',
        label: 'Dirección',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'localidad',
        label: 'Localidad',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'provincia',
        label: 'Provincia',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'telefono',
        label: 'Teléfono',
        inputType: { type: InputType.EDIT_TEXT },
    },
    {
        field: 'fax',
        label: 'Fax',
        inputType: { type: InputType.EDIT_TEXT },
    }];

    formChanges(tag: string) {
        this.lastFieldChanged = tag;
    }
}
